export class Evenement{
    id = 0
    titre = ''
    description = ''
    date = ''
    lienExterne : string | null = ''
    afficheApplication = false
    afficheSiteVitrine = false
    identifiantTelechargementImage = null as null | string
}